import * as React from 'react';
import { useMeasure } from 'react-use';
import styled from 'styled-components';
import cl from 'classnames';

import { IconArrowsCheckO } from '@doltech/icons/IconArrowsCheckO';
import { Typography } from '../../DesignSystemV2/Typography';
import { colorsV2 } from '../../colors-v2';

const SMALL_CONTAINER_MAX_WIDTH = 580;

const ListItem = styled.div`
  display: flex;
  align-items: center;

  span {
    white-space: nowrap;
  }
`;

const List = styled.div`
  display: flex;
  flex-flow: column wrap;
  color: ${colorsV2.black80};

  ${ListItem} {
    &:not(:last-child) {
      margin-bottom: 4px;
    }
  }

  &.horizontal {
    flex-direction: row;

    ${ListItem} {
      &:not(:last-child) {
        margin-right: 16px;
        margin-bottom: 0;
      }
    }
  }
`;

interface UnorderedListProps {
  list: string[];
  icon?: React.ReactNode;
  maxWidth?: number;
}

export const UnorderedList = (props: UnorderedListProps) => {
  const { list, icon, maxWidth = SMALL_CONTAINER_MAX_WIDTH } = props;
  const [ref, { width }] = useMeasure();

  return (
    <List ref={ref} className={cl({ horizontal: width > maxWidth })}>
      {list.map((text, index) => (
        <ListItem key={index}>
          {icon || <IconArrowsCheckO fontSize={16} mr="8px" />}
          <Typography.Text variant="medium/14">{text}</Typography.Text>
        </ListItem>
      ))}
    </List>
  );
};
